import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createCheckoutFromSubmission as universalCreateCheckoutFromSubmission, isFormSubmittable as universalIsFormSubmittable, createSubmission as universalCreateSubmission, createSubmissionBySubmitter as universalCreateSubmissionBySubmitter, bulkCreateSubmissionBySubmitter as universalBulkCreateSubmissionBySubmitter, getSubmission as universalGetSubmission, getSubmissionByCheckoutId as universalGetSubmissionByCheckoutId, updateSubmission as universalUpdateSubmission, confirmSubmission as universalConfirmSubmission, deleteSubmission as universalDeleteSubmission, bulkDeleteSubmission as universalBulkDeleteSubmission, restoreSubmissionFromTrashBin as universalRestoreSubmissionFromTrashBin, removeSubmissionFromTrashBin as universalRemoveSubmissionFromTrashBin, bulkRemoveSubmissionFromTrashBin as universalBulkRemoveSubmissionFromTrashBin, listDeletedSubmissions as universalListDeletedSubmissions, getDeletedSubmission as universalGetDeletedSubmission, querySubmission as universalQuerySubmission, searchSubmissionsByNamespace as universalSearchSubmissionsByNamespace, searchSubmissionsByNamespaceForExport as universalSearchSubmissionsByNamespaceForExport, querySubmissionsByNamespace as universalQuerySubmissionsByNamespace, querySubmissionsByNamespaceForExport as universalQuerySubmissionsByNamespaceForExport, countSubmissionsByFilter as universalCountSubmissionsByFilter, countSubmissions as universalCountSubmissions, countDeletedSubmissions as universalCountDeletedSubmissions, getMediaUploadUrl as universalGetMediaUploadUrl, bulkMarkSubmissionsAsSeen as universalBulkMarkSubmissionsAsSeen, upsertContactFromSubmission as universalUpsertContactFromSubmission, } from './forms-v4-submission.universal';
import { SubmissionStatus, OptInLevel, RequiredIndicator, RequiredIndicatorPlacement, Format, ValidationFormat, ProductType, PriceType, FormatEnumFormat, StringComponentType, NodeType, WidthType, PluginContainerDataAlignment, ButtonDataType, LinkTarget, TextAlignment, LineStyle, Width, Alignment, ViewMode, LayoutType, Orientation, Crop, ThumbnailsAlignment, Source, MapType, ViewRole, VoteRole, PollLayoutType, PollLayoutDirection, BackgroundType, DecorationType, FontType, AppType, InitialExpandedItems, Direction, VerticalAlignment, NullValue, DateFormatPart, FirstDayOfWeek, DateTimeInputType, NumberComponentType, BooleanComponentType, ItemType, PropertiesTypePropertiesType, ComponentType, WixFileComponentType, UploadFileFormat, PaymentComponentType, NumberOfColumns, MultilineAddressComponentType, Type, InputType, EmailInfoTag, PhoneInfoTag, Tag, SubscriptionInfoOptInLevel, ContactField, Target, FieldType, OverrideEntityType, Kind, SpamFilterProtectionLevel, UrlTargetEnumTarget, SubmitSuccessAction, WebhookIdentityType, SortOrder, Mode, IdentityType, } from './forms-v4-submission.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.forms.v4.submission', module_name: 'wix-forms.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createCheckoutFromSubmission: (options) => {
            const methodLogData = {
                method_name: 'createCheckoutFromSubmission',
                service_name: 'wix.forms.v4.FormPaymentService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormPaymentService.createCheckoutFromSubmission',
            };
            return universalCreateCheckoutFromSubmission(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        isFormSubmittable: () => {
            const methodLogData = {
                method_name: 'isFormSubmittable',
                service_name: 'wix.forms.v4.FormPaymentService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormPaymentService.isFormSubmittable',
            };
            return universalIsFormSubmittable(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createSubmission: (submission, options) => {
            const methodLogData = {
                method_name: 'createSubmission',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.createSubmission',
            };
            return universalCreateSubmission(submission, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createSubmissionBySubmitter: (submission, options) => {
            const methodLogData = {
                method_name: 'createSubmissionBySubmitter',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.createSubmissionBySubmitter',
            };
            return universalCreateSubmissionBySubmitter(submission, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateSubmissionBySubmitter: (formId, options) => {
            const methodLogData = {
                method_name: 'bulkCreateSubmissionBySubmitter',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.bulkCreateSubmissionBySubmitter',
            };
            return universalBulkCreateSubmissionBySubmitter(formId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getSubmission: (submissionId) => {
            const methodLogData = {
                method_name: 'getSubmission',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.getSubmission',
            };
            return universalGetSubmission(submissionId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getSubmissionByCheckoutId: (checkoutId) => {
            const methodLogData = {
                method_name: 'getSubmissionByCheckoutId',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.getSubmissionByCheckoutId',
            };
            return universalGetSubmissionByCheckoutId(checkoutId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateSubmission: (_id, submission, options) => {
            const methodLogData = {
                method_name: 'updateSubmission',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.updateSubmission',
            };
            return universalUpdateSubmission(_id, submission, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        confirmSubmission: (submissionId) => {
            const methodLogData = {
                method_name: 'confirmSubmission',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.confirmSubmission',
            };
            return universalConfirmSubmission(submissionId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteSubmission: (submissionId, options) => {
            const methodLogData = {
                method_name: 'deleteSubmission',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.deleteSubmission',
            };
            return universalDeleteSubmission(submissionId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteSubmission: (formId, options) => {
            const methodLogData = {
                method_name: 'bulkDeleteSubmission',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.bulkDeleteSubmission',
            };
            return universalBulkDeleteSubmission(formId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        restoreSubmissionFromTrashBin: (submissionId) => {
            const methodLogData = {
                method_name: 'restoreSubmissionFromTrashBin',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.restoreSubmissionFromTrashBin',
            };
            return universalRestoreSubmissionFromTrashBin(submissionId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeSubmissionFromTrashBin: (submissionId) => {
            const methodLogData = {
                method_name: 'removeSubmissionFromTrashBin',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.removeSubmissionFromTrashBin',
            };
            return universalRemoveSubmissionFromTrashBin(submissionId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkRemoveSubmissionFromTrashBin: (formId, options) => {
            const methodLogData = {
                method_name: 'bulkRemoveSubmissionFromTrashBin',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.bulkRemoveSubmissionFromTrashBin',
            };
            return universalBulkRemoveSubmissionFromTrashBin(formId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listDeletedSubmissions: (formId, options) => {
            const methodLogData = {
                method_name: 'listDeletedSubmissions',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.listDeletedSubmissions',
            };
            return universalListDeletedSubmissions(formId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getDeletedSubmission: (submissionId) => {
            const methodLogData = {
                method_name: 'getDeletedSubmission',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.getDeletedSubmission',
            };
            return universalGetDeletedSubmission(submissionId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        querySubmission: (query, options) => {
            const methodLogData = {
                method_name: 'querySubmission',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.querySubmission',
            };
            return universalQuerySubmission(query, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        searchSubmissionsByNamespace: (search) => {
            const methodLogData = {
                method_name: 'searchSubmissionsByNamespace',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.searchSubmissionsByNamespace',
            };
            return universalSearchSubmissionsByNamespace(search, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        searchSubmissionsByNamespaceForExport: (query) => {
            const methodLogData = {
                method_name: 'searchSubmissionsByNamespaceForExport',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.searchSubmissionsByNamespaceForExport',
            };
            return universalSearchSubmissionsByNamespaceForExport(query, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        querySubmissionsByNamespace: (options) => {
            const methodLogData = {
                method_name: 'querySubmissionsByNamespace',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.querySubmissionsByNamespace',
            };
            return universalQuerySubmissionsByNamespace(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        querySubmissionsByNamespaceForExport: (query) => {
            const methodLogData = {
                method_name: 'querySubmissionsByNamespaceForExport',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.querySubmissionsByNamespaceForExport',
            };
            return universalQuerySubmissionsByNamespaceForExport(query, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countSubmissionsByFilter: (filter, options) => {
            const methodLogData = {
                method_name: 'countSubmissionsByFilter',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.countSubmissionsByFilter',
            };
            return universalCountSubmissionsByFilter(filter, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countSubmissions: (formIds, namespace, options) => {
            const methodLogData = {
                method_name: 'countSubmissions',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.countSubmissions',
            };
            return universalCountSubmissions(formIds, namespace, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countDeletedSubmissions: (formIds, namespace, options) => {
            const methodLogData = {
                method_name: 'countDeletedSubmissions',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.countDeletedSubmissions',
            };
            return universalCountDeletedSubmissions(formIds, namespace, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getMediaUploadUrl: (formId, filename, mimeType) => {
            const methodLogData = {
                method_name: 'getMediaUploadUrl',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.getMediaUploadUrl',
            };
            return universalGetMediaUploadUrl(formId, filename, mimeType, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkMarkSubmissionsAsSeen: (ids, formId) => {
            const methodLogData = {
                method_name: 'bulkMarkSubmissionsAsSeen',
                service_name: 'wix.forms.v4.FormSubmissionService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionService.bulkMarkSubmissionsAsSeen',
            };
            return universalBulkMarkSubmissionsAsSeen(ids, formId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        upsertContactFromSubmission: (submissionId, options) => {
            const methodLogData = {
                method_name: 'upsertContactFromSubmission',
                service_name: 'wix.forms.v4.FormSubmissionContactUpsertService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forms.v2,entity=wix.forms.v4.submission,environment=velo-frontend,method-fqn=wix.forms.v4.FormSubmissionContactUpsertService.upsertContactFromSubmission',
            };
            return universalUpsertContactFromSubmission(submissionId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        SubmissionStatus,
        OptInLevel,
        RequiredIndicator,
        RequiredIndicatorPlacement,
        Format,
        ValidationFormat,
        ProductType,
        PriceType,
        FormatEnumFormat,
        StringComponentType,
        NodeType,
        WidthType,
        PluginContainerDataAlignment,
        ButtonDataType,
        LinkTarget,
        TextAlignment,
        LineStyle,
        Width,
        Alignment,
        ViewMode,
        LayoutType,
        Orientation,
        Crop,
        ThumbnailsAlignment,
        Source,
        MapType,
        ViewRole,
        VoteRole,
        PollLayoutType,
        PollLayoutDirection,
        BackgroundType,
        DecorationType,
        FontType,
        AppType,
        InitialExpandedItems,
        Direction,
        VerticalAlignment,
        NullValue,
        DateFormatPart,
        FirstDayOfWeek,
        DateTimeInputType,
        NumberComponentType,
        BooleanComponentType,
        ItemType,
        PropertiesTypePropertiesType,
        ComponentType,
        WixFileComponentType,
        UploadFileFormat,
        PaymentComponentType,
        NumberOfColumns,
        MultilineAddressComponentType,
        Type,
        InputType,
        EmailInfoTag,
        PhoneInfoTag,
        Tag,
        SubscriptionInfoOptInLevel,
        ContactField,
        Target,
        FieldType,
        OverrideEntityType,
        Kind,
        SpamFilterProtectionLevel,
        UrlTargetEnumTarget,
        SubmitSuccessAction,
        WebhookIdentityType,
        SortOrder,
        Mode,
        IdentityType,
    };
}
//# sourceMappingURL=forms-v4-submission.frontend.js.map